import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home.vue'
import Login from '@/components/Login'
import Forbidden from '@/components/Forbidden'

import Errors from '@/components/errors/ErrorOverview'
import Orders from '@/components/orders/OrderOverview'

import { getInstance } from '../services/AuthenticationService'

Vue.use(Router)

let router = new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
       meta: {
        requiresAuth: true
      }
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
      beforeEnter: (to, from, next) => {
        const authService = getInstance()

        if (authService.isAuthenticated) {
          next({ name: 'home' })
        } else {
          next()
        }
      },
      meta: {
        requiresAuth: false
      }
    },
    {
      path: '/forbidden',
      name: 'forbidden',
      component: Forbidden,
      meta: {
        requiresAuth: false
      }
    },
    {
      path: '/errors',
      name: 'errorOverview',
      component: Errors,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/orders',
      name: 'orderOverview',
      component: Orders,
      meta: {
        requiresAuth: true
      }
    },
  ]
})

router.beforeEach((to, from, next) => {
  const authService = getInstance()

  if (to.meta.requiresAuth && !authService.isAuthenticated) {
    next({ name: 'login' })
  } else if (to.meta.onlyFor && !authService.userIsInAGroup(to.meta.onlyFor)) {
    next({ name: 'forbidden' })
  } else {
    next()
  }
})

export default router




// WEBPACK FOOTER //
// ./src/router/index.js